<template>
	<div class="container-box">
		<div :id="id" :style="{height:height,width:width}"></div>
	</div>
</template>

<script>
	import echarts from 'echarts';
	export default {
		props: ['className', 'id', 'height', 'width', 'type', 'echartsData'],
		data() {
			return {}
		},
		mounted() {
			if(this.type=='alarm'){
			let result = this.echartsData;
			let dataAxis = [],
				series = [],
				danger = [],
				warning = [],
				normal = [],
				other = [];
			dataAxis = result.map(item => {
				return {
					value: item.areaName,
					textStyle: {
						color: '#04C3F1'
					},
				}
			})
			let type = result.map(item => {
				let re1=item.data.find(citem=>citem.type=='紧急');
				let re2=item.data.find(citem=>citem.type=='重要');
				let re3=item.data.find(citem=>citem.type=='一般');
				let re4=item.data.find(citem=>citem.type=='其他');
				danger.push(re1&&re1.num?re1.num:0);
				warning.push(re2&&re2.num?re2.num:0);
				normal.push(re3&&re3.num?re3.num:0);
				other.push(re4&&re4.num?re4.num:0);
			})
			series = [{
					name: '紧急',
					type: 'bar',
					label: {
						show: false,
						position: 'insideRight'
					},
					barWidth: '40%',
					data: danger
				},
				{
					name: '重要',
					type: 'bar',
					label: {
						show: false,
						position: 'insideRight'
					},
					data: warning
				},
				{
					name: '一般',
					type: 'bar',
					label: {
						show: false,
						position: 'insideRight'
					},
					data: normal
				},
				{
					name: '其他',
					type: 'bar',
					label: {
						show: false,
						position: 'insideRight'
					},
					data: other
				},
			]
			this.initData(dataAxis, series);
			}else if(this.type=='camera'){
				// PC("PC","后端登录"),
				//     STB("STB","机顶盒登录"),
				//     THIRD("THIRD","第三方登录"),
				//     MOVE_APP("MOVE_APP","移动端-APP"),
				//     MOVE_WX("MOVE_WX","移动端-微信登录"),
				//     MOVE_DD("MOVE_DD","移动端-钉钉登录")、
				
				let result = this.echartsData;
				let dataAxis = [],
					series = [],
					PC = [],
					STB = [],
					THIRD = [],
					MOVE_APP = [],
					MOVE_WX = [],
					MOVE_DD = [];
				dataAxis = result.map(item => {
					return {
						value: item.monthOrDayOrHour,
						textStyle: {
							color: '#04C3F1'
						}
					}
				})
				result.map(citem => {
					let rePC=citem.list.find(citem=>citem.type=='PC');
					let reSTB=citem.list.find(citem=>citem.type=='STB');
					let reTHIRD=citem.list.find(citem=>citem.type=='THIRD');
					let reMOVE_APP=citem.list.find(citem=>citem.type=='MOVE_APP');
					let reMOVE_WX=citem.list.find(citem=>citem.type=='MOVE_WX');
					let reMOVE_DD=citem.list.find(citem=>citem.type=='MOVE_DD');
					PC.push(rePC&&rePC.num?rePC.num:0);
					STB.push(reSTB&&reSTB.num?reSTB.num:0);
					THIRD.push(reTHIRD&&reTHIRD.num?reTHIRD.num:0);
					MOVE_APP.push(reMOVE_APP&&reMOVE_APP.num?reMOVE_APP.num:0);
					MOVE_WX.push(reMOVE_WX&&reMOVE_WX.num?reMOVE_WX.num:0);
					MOVE_DD.push(reMOVE_DD&&reMOVE_DD.num?reMOVE_DD.num:0);
				})
				series = [{
						name: 'PC',
						type: 'bar',
						label: {
							show: false,
							position: 'insideRight'
						},
						barWidth: '40%',
						data: PC
					},
					{
						name: 'STB',
						type: 'bar',
						label: {
							show: false,
							position: 'insideRight'
						},
						data: STB
					},
					{
						name: 'THIRD',
						type: 'bar',
						label: {
							show: false,
							position: 'insideRight'
						},
						data: THIRD
					},
					{
						name: 'MOVE_APP',
						type: 'bar',
						label: {
							show: false,
							position: 'insideRight'
						},
						data: MOVE_APP
					},
					{
						name: 'MOVE_WX',
						type: 'bar',
						label: {
							show: false,
							position: 'insideRight'
						},
						data: MOVE_WX
					},
					{
						name: 'MOVE_DD',
						type: 'bar',
						label: {
							show: false,
							position: 'insideRight'
						},
						data: MOVE_DD
					}
				]
			this.initData(dataAxis, series);
			}
			
		},
		beforeDestroy() {

		},
		methods: {

			initData(dataAxis, series) {
				// 基于准备好的dom，初始化echarts实例
				let myChart = echarts.init(document.getElementById(this.id))
				// 绘制图表
				myChart.setOption({
					color: ['#d38197','#cfc9a5', '#55d1d8', '#24f3b7'],
					tooltip: {
						trigger: 'axis',
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					grid: {
						left: '3%',
						right: '4%',
						top: '3%',
						containLabel: true
					},
					yAxis: {
						type: 'value',
						show: false,
					},
					xAxis: {
						type: 'category',
						nameTextStyle: {
							color: '#fff'
						},
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						data: dataAxis
					},
					series: series
				})
			},

		}
	}
</script>

<style lang="less" scoped>
</style>
